<template>
  <div>
    <ModuleHeader>Campañas Whatsapp</ModuleHeader>

    <v-tabs v-model="activeTab">
      <v-tab>Proceso de envío</v-tab>
      <v-tab>Historial de envíos</v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <!-- V-Stepper para manejar los pasos -->
        <v-stepper v-model="step">
          <!-- Header del v-stepper -->
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">
              Selecciona el template
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">
              Rellena los mensajes
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3"> Enviar </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Selecciona el template -->
            <v-stepper-content step="1">
              <v-card title="Templates" flat>
                <v-row v-if="!loading">
                  <template v-for="template in templates">
                    <v-col
                      :key="template.id"
                      cols="12"
                      sm="6"
                      md="3"
                      class="d-flex mb-3"
                    >
                      <v-card
                        style="
                          height: 100%;
                          display: flex;
                          flex-direction: column;
                          width: 100%;
                        "
                        class="ma-2 pa-2 d-flex flex-column fill-height"
                        outlined
                        elevation="2"
                      >
                        <!-- <v-row> -->
                        <v-btn
                          plain
                          @click="template.activeTab = 0"
                          v-show="template.activeTab == 1"
                          class="v-tab-like"
                          >Ver detalles</v-btn
                        >
                        <v-btn
                          plain
                          @click="template.activeTab = 1"
                          v-show="template.activeTab == 0"
                          class="v-tab-like"
                          >Ver vista previa</v-btn
                        >

                        <!-- </v-row> -->

                        <!-- Tab 1: Detalles del template -->
                        <div
                          v-if="template.activeTab == 0"
                          style="
                            flex-grow: 1;
                            display: flex;
                            flex-direction: column;
                            overflow-y: auto;
                          "
                        >
                          <!-- Nombre del template -->
                          <v-card-title class="text-h6 font-weight-bold">
                            {{ template.name }}
                          </v-card-title>

                          <!-- Divider decorativo -->
                          <v-divider></v-divider>

                          <!-- Componentes del template -->
                          <template v-for="component in template.components">
                            <!-- Header del template -->
                            <v-card-subtitle
                              :key="component.type"
                              v-if="component.type === 'HEADER'"
                              class="text-subtitle-1 mt-2"
                            >
                              <v-icon left>mdi-format-header-1</v-icon>
                              <strong>Header:</strong>
                              <div>
                                <div v-if="component.format === 'TEXT'">
                                  {{ component.text }}
                                </div>
                                <v-img
                                  v-else-if="component.format === 'IMAGE'"
                                  :src="component.example.header_handle[0]"
                                  max-height="100"
                                  contain
                                  class="rounded ma-1"
                                ></v-img>
                                <iframe
                                  v-else-if="
                                    ['VIDEO', 'DOCUMENT'].includes(
                                      component.format
                                    )
                                  "
                                  :src="component.example.header_handle[0]"
                                  max-height="100"
                                  class="rounded ma-1 iframe"
                                ></iframe>
                                <div
                                  v-else-if="component.format === 'LOCATION'"
                                  max-height="100"
                                  class="rounded ma-1"
                                >
                                  Ubicación
                                </div>
                              </div>
                            </v-card-subtitle>

                            <!-- Cuerpo del template -->
                            <v-card-text
                              :key="component.type"
                              v-if="component.type === 'BODY'"
                              class="text-body-2"
                            >
                              <v-icon left>mdi-text</v-icon>
                              <strong>Body:</strong>
                              <p>{{ component.text }}</p>
                            </v-card-text>

                            <!-- Footer del template -->
                            <v-card-subtitle
                              :key="component.type"
                              v-if="component.type === 'FOOTER'"
                              class="text-subtitle-1 mt-2"
                            >
                              <v-icon left>mdi-information-outline</v-icon>
                              <strong>Footer:</strong>
                              <div>{{ component.text }}</div>
                            </v-card-subtitle>

                            <!-- Botones del template -->
                            <v-list
                              :key="component.type"
                              v-if="component.type === 'BUTTONS'"
                              dense
                              class="mt-2"
                            >
                              <v-subheader>Buttons</v-subheader>
                              <v-list-item
                                v-for="(button, btnIndex) in component.buttons"
                                :key="btnIndex"
                                class="py-1"
                              >
                                <v-list-item-icon>
                                  <v-icon>
                                    {{
                                      button.type === "QUICK_REPLY"
                                        ? "mdi-reply"
                                        : button.type === "URL"
                                        ? "mdi-link"
                                        : button.type === "CALL"
                                        ? "mdi-phone"
                                        : ""
                                    }}
                                  </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    button.text
                                  }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </template>

                          <!-- Acciones -->
                          <v-spacer></v-spacer>
                          <v-card-actions
                            style="margin-top: auto; justify-content: flex-end"
                          >
                            <v-btn
                              color="primary"
                              outlined
                              @click="selectTemplate(template)"
                            >
                              Usar Template
                            </v-btn>
                          </v-card-actions>
                        </div>

                        <!-- Tab 2: Vista previa del mensaje -->
                        <div v-if="template.activeTab == 1">
                          <div class="whatsapp-message">
                            <template v-for="component in template.components">
                              <!-- Header -->
                              <div
                                :key="component.type"
                                v-if="component.type === 'HEADER'"
                                class="message-header"
                              >
                                <v-icon left>mdi-format-header-1</v-icon>
                                <strong>
                                  <span v-if="component.format === 'TEXT'">{{
                                    component.text
                                  }}</span>
                                  <v-img
                                    v-else-if="component.format === 'IMAGE'"
                                    :src="component.example.header_handle[0]"
                                    max-height="200"
                                    contain
                                    class="rounded ma-1"
                                  ></v-img>
                                  <iframe
                                    v-else-if="
                                      ['VIDEO', 'DOCUMENT'].includes(
                                        component.format
                                      )
                                    "
                                    :src="component.example.header_handle[0]"
                                    max-height="200"
                                    class="rounded ma-1 iframe"
                                  ></iframe>
                                  <div
                                    v-else-if="component.format === 'LOCATION'"
                                    max-height="200"
                                    class="rounded ma-1"
                                  >
                                    Ubicación
                                  </div>
                                </strong>
                              </div>

                              <!-- Body -->
                              <div
                                :key="component.type"
                                v-if="component.type === 'BODY'"
                                class="message-body"
                              >
                                <p>{{ component.text }}</p>
                              </div>

                              <!-- Footer -->
                              <div
                                :key="component.type"
                                v-if="component.type === 'FOOTER'"
                                class="message-footer"
                              >
                                <small>{{ component.text }}</small>
                              </div>

                              <!-- Buttons -->
                              <v-row
                                :key="component.type"
                                v-if="component.type === 'BUTTONS'"
                                class="button-container"
                              >
                                <v-col
                                  v-for="(button, index) in component.buttons"
                                  :key="index"
                                  cols="12"
                                >
                                  <v-btn
                                    :class="{
                                      'button-active':
                                        button.type === 'QUICK_REPLY',
                                      'button-secondary':
                                        button.type !== 'QUICK_REPLY',
                                    }"
                                    :href="
                                      button.type === 'URL' ? button.url : null
                                    "
                                    block
                                    disabled
                                  >
                                    <v-icon left>
                                      {{
                                        button.type === "QUICK_REPLY"
                                          ? "mdi-reply"
                                          : button.type === "URL"
                                          ? "mdi-link"
                                          : "mdi-help"
                                      }}
                                    </v-icon>
                                    {{ button.text }}
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </template>
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                  </template>
                </v-row>

                <v-progress-circular
                  v-else
                  indeterminate
                  color="primary"
                  class="ma-auto"
                >
                </v-progress-circular>
              </v-card>
            </v-stepper-content>

            <!-- Paso 2:  Rellena los mensajes -->
            <v-stepper-content step="2">
              <v-btn color="primary" @click="moveStep(false)">
                Regresar al paso anterior
              </v-btn>

              <v-card class="pa-3" v-if="selectedTemplate">
                <v-card-title>Vista previa del mensaje</v-card-title>
                <v-card-text>
                  <v-row>
                    <!-- Sección para personalizar los placeholders -->
                    <v-col cols="12" md="6">
                      <h4>Personaliza los valores:</h4>
                      <v-form>
                        <!-- Header Placeholders y Media Management -->
                        <div v-if="headerData.exist" class="mt-4">
                          <h5>Header</h5>

                          <!-- Header of type TEXT -->
                          <div v-if="headerData.type === 'TEXT'">
                            <template
                              v-for="(
                                placeholder, key
                              ) in headerData.placeholders"
                            >
                              <v-text-field
                                :key="`header-placeholder-${key}`"
                                :label="`Valor para ${key}`"
                                v-model="headerData.placeholders[key]"
                                outlined
                                dense
                                @input="updateFormattedHeader"
                              ></v-text-field>
                            </template>
                          </div>

                          <!-- Header of type IMAGE, VIDEO, DOCUMENT -->
                          <div
                            v-else-if="
                              ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(
                                headerData.type
                              )
                            "
                          >
                            <v-row>
                              <v-col md="0" v-show="false"
                                ><v-text-field
                                  label="URL de la media"
                                  v-model="headerData.media.url"
                                  outlined
                                  dense
                                  @input="updateHeaderMediaUrl"
                                ></v-text-field>
                              </v-col>
                              <v-col md="12"
                                ><v-btn block @click="imageModal = true">
                                  <v-icon>mdi-image-plus</v-icon>
                                </v-btn></v-col
                              >
                            </v-row>
                          </div>

                          <!-- Header of type LOCATION -->
                          <div v-if="headerData.type === 'LOCATION'">
                            <v-text-field
                              label="URL de la ubicación"
                              v-model="headerData.media.url"
                              outlined
                              dense
                              @input="updateHeaderMediaUrl"
                            ></v-text-field>
                            <v-text-field
                              label="Nombre de la ubicación"
                              v-model="headerData.media.name"
                              outlined
                              dense
                              @input="updateHeaderMediaUrl"
                            ></v-text-field>
                          </div>
                        </div>

                        <!-- Body Placeholders -->
                        <div
                          v-if="Object.keys(placeholders).length > 0"
                          class="mt-4"
                        >
                          <h5>Body</h5>
                          <v-divider></v-divider>
                          <template v-for="(placeholder, key) in placeholders">
                            <v-text-field
                              :key="`body-${key}`"
                              :label="`Valor para ${key}`"
                              v-model="placeholders[key]"
                              outlined
                              dense
                              @input="updateFormattedBody"
                            ></v-text-field>
                          </template>
                        </div>
                      </v-form>
                    </v-col>

                    <!-- Sección de vista previa del mensaje -->
                    <v-col cols="12" md="6">
                      <div class="whatsapp-message">
                        <!-- Header del mensaje, si existe -->
                        <div
                          v-if="
                            selectedTemplate.components.some(
                              (c) => c.type === 'HEADER'
                            )
                          "
                          class="message-header"
                        >
                          <v-icon left>mdi-format-header-1</v-icon>
                          <strong>
                            <template
                              v-for="(
                                component, index
                              ) in selectedTemplate.components"
                            >
                              <!-- Header tipo TEXT -->
                              <span
                                :key="index"
                                v-if="
                                  component.type === 'HEADER' &&
                                  component.format === 'TEXT'
                                "
                              >
                                {{
                                  headerData.formattedHeader || component.text
                                }}
                              </span>

                              <!-- Header tipo LOCATION -->
                              <div
                                :key="index"
                                v-else-if="
                                  component.type === 'HEADER' &&
                                  component.format === 'LOCATION'
                                "
                                class="text-center"
                              >
                                Ubicación
                              </div>

                              <!-- Header tipo IMAGE, VIDEO, DOCUMENT -->
                              <!-- <iframe
                                :key="index"
                                v-else-if="
                                  component.type === 'HEADER' &&
                                  ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(
                                    component.format
                                  )
                                "
                                :src="component.example?.header_handle?.[0]"
                                max-height="200"
                                contain
                                class="rounded ma-1 iframe"
                              ></iframe> -->

                              <!-- Header tipo IMAGE -->
                              <v-img
                                :key="index"
                                v-else-if="component.format === 'IMAGE'"
                                :src="component.example.header_handle[0]"
                                max-height="200"
                                contain
                                class="rounded ma-1"
                              ></v-img>

                              <!-- Header tipo VIDEO o DOCUMENT -->
                              <iframe
                                :key="index"
                                v-else-if="
                                  ['VIDEO', 'DOCUMENT'].includes(
                                    component.format
                                  )
                                "
                                :src="component.example.header_handle[0]"
                                max-height="200"
                                class="rounded ma-1 iframe"
                              ></iframe>
                            </template>
                          </strong>
                        </div>

                        <!-- Cuerpo del mensaje formateado -->
                        <div class="message-body">
                          <template
                            v-for="(
                              component, compIndex
                            ) in selectedTemplate.components"
                          >
                            <p
                              :key="compIndex"
                              v-if="component.type === 'BODY'"
                            >
                              {{ formattedBody || component.text }}
                            </p>
                          </template>

                          <!-- Footer del mensaje -->
                          <div
                            v-if="
                              selectedTemplate.components.some(
                                (c) => c.type === 'FOOTER'
                              )
                            "
                          >
                            <small>
                              {{
                                selectedTemplate.components.find(
                                  (c) => c.type === "FOOTER"
                                ).text
                              }}
                            </small>
                          </div>
                        </div>

                        <!-- Botones del mensaje, si existen -->
                        <v-row
                          v-if="buttons.length > 0"
                          class="button-container mt-3"
                        >
                          <v-col
                            v-for="(button, index) in buttons"
                            :key="index"
                            cols="12"
                          >
                            <v-btn
                              :class="{
                                'button-active': button.type === 'quick_reply',
                                'button-secondary': button.type === 'URL',
                                'button-default': ![
                                  'quick_reply',
                                  'URL',
                                ].includes(button.type),
                              }"
                              :href="button.type === 'URL' ? button.url : null"
                              block
                              disabled
                            >
                              <v-icon left>
                                {{
                                  button.type === "quick_reply"
                                    ? "mdi-reply"
                                    : button.type === "URL"
                                    ? "mdi-link"
                                    : "mdi-help"
                                }}
                              </v-icon>
                              {{ button.text }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- Botón "Enviar" -->
                  <v-btn
                    :disabled="!placeholdersFilled"
                    color="success"
                    class="mt-3"
                    @click="moveStep(true)"
                    block
                  >
                    Enviar
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <!-- Paso 3: Enviar -->
            <v-stepper-content step="3">
              <v-btn color="primary" @click="moveStep(false)">
                Regresar al paso anterior
              </v-btn>

              <v-card class="pa-3 mt-4">
                <v-card-text>
                  <v-row>
                    <!-- Vista previa del mensaje -->
                    <v-col cols="12" md="6" class="mx-auto">
                      <h4 class="mb-3 text-center">Vista previa del mensaje</h4>
                      <div class="whatsapp-message" v-if="selectedTemplate">
                        <!-- Header del mensaje, si existe -->
                        <div
                          v-if="
                            selectedTemplate.components.some(
                              (c) => c.type === 'HEADER'
                            )
                          "
                          class="message-header"
                        >
                          <v-icon left>mdi-format-header-1</v-icon>
                          <strong>
                            <template
                              v-for="(
                                component, index
                              ) in selectedTemplate.components"
                            >
                              <!-- Header tipo TEXT -->
                              <span
                                :key="index"
                                v-if="
                                  component.type === 'HEADER' &&
                                  component.format === 'TEXT'
                                "
                              >
                                {{
                                  headerData.formattedHeader || component.text
                                }}
                              </span>

                              <!-- Header tipo LOCATION -->
                              <div
                                :key="index"
                                v-else-if="
                                  component.type === 'HEADER' &&
                                  component.format === 'LOCATION'
                                "
                                class="text-center"
                              >
                                Ubicación
                              </div>

                              <!-- Header tipo IMAGE, VIDEO, DOCUMENT -->
                              <!-- <iframe
                                :key="index"
                                v-else-if="
                                  component.type === 'HEADER' &&
                                  ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(
                                    component.format
                                  )
                                "
                                :src="component.example?.header_handle?.[0]"
                                max-height="200"
                                contain
                                class="rounded ma-1 iframe"
                              ></iframe> -->
                              <!-- Header tipo IMAGE -->
                              <v-img
                                :key="index"
                                v-else-if="component.format === 'IMAGE'"
                                :src="component.example.header_handle[0]"
                                max-height="200"
                                contain
                                class="rounded ma-1"
                              ></v-img>

                              <!-- Header tipo VIDEO o DOCUMENT -->
                              <iframe
                                :key="index"
                                v-else-if="
                                  ['VIDEO', 'DOCUMENT'].includes(
                                    component.format
                                  )
                                "
                                :src="component.example.header_handle[0]"
                                max-height="200"
                                class="rounded ma-1 iframe"
                              ></iframe>
                            </template>
                          </strong>
                        </div>

                        <!-- Cuerpo del mensaje formateado -->
                        <div class="message-body">
                          <template
                            v-for="(
                              component, compIndex
                            ) in selectedTemplate.components"
                          >
                            <p
                              :key="compIndex"
                              v-if="component.type === 'BODY'"
                            >
                              {{ formattedBody || component.text }}
                            </p>
                          </template>

                          <!-- Footer del mensaje -->
                          <div
                            v-if="
                              selectedTemplate.components.some(
                                (c) => c.type === 'FOOTER'
                              )
                            "
                          >
                            <small>
                              {{
                                selectedTemplate.components.find(
                                  (c) => c.type === "FOOTER"
                                ).text
                              }}
                            </small>
                          </div>
                        </div>

                        <!-- Botones del mensaje, si existen -->
                        <v-row
                          v-if="buttons.length > 0"
                          class="button-container mt-3"
                        >
                          <v-col
                            v-for="(button, index) in buttons"
                            :key="index"
                            cols="12"
                          >
                            <v-btn
                              :class="{
                                'button-active': button.type === 'quick_reply',
                                'button-secondary': button.type === 'URL',
                                'button-default': ![
                                  'quick_reply',
                                  'URL',
                                ].includes(button.type),
                              }"
                              :href="button.type === 'URL' ? button.url : null"
                              block
                              disabled
                            >
                              <v-icon left>
                                {{
                                  button.type === "quick_reply"
                                    ? "mdi-reply"
                                    : button.type === "URL"
                                    ? "mdi-link"
                                    : "mdi-help"
                                }}
                              </v-icon>
                              {{ button.text }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>

                    <!-- Selección de destinatarios -->
                    <v-col cols="12" md="6">
                      <h4 class="mb-3">Selecciona los destinatarios</h4>
                      <v-select
                        v-model="selectedSegments"
                        :items="segments"
                        item-text="segment"
                        item-value="segment"
                        label="Selecciona los destinatarios"
                        chips
                        outlined
                      ></v-select>

                      <v-btn
                        v-if="selectedSegments.length > 0"
                        :loading="loadingSend"
                        color="success"
                        class="mt-4"
                        block
                        @click="
                          sendMessageToSegments();
                          loadingSend = true;
                        "
                      >
                        Enviar mensaje
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-tab-item>
      <v-tab-item>
        <DataTable
          :config="config"
          :data="campañas"
          :pageRows="15"
          @buttonClick="dtButtonClick"
        ></DataTable>
      </v-tab-item>
    </v-tabs-items>

    <modal v-model="imageModal">
      <GaleriaCampanas @autoImage="autoImage"></GaleriaCampanas>
    </modal>
  </div>
</template>

<script>
import axiosCore from "axios";
import GaleriaCampanas from "./GaleriaCampanas.vue";
import DataTable from "../../MainComponents/DataTable.vue";
import moment from "moment";
export default {
  name: "CampañasWhatsapp",
  components: {
    GaleriaCampanas,
    DataTable,
  },
  data() {
    return {
      templates: [],
      step: 1,
      placeholders: [],
      headerData: {
        exist: false,
        type: null, // El tipo de HEADER (TEXT, IMAGE, VIDEO, DOCUMENT, LOCATION)
        placeholders: {}, // Los placeholders del HEADER (si es TEXT)
        media: {
          url: null, // La URL de media (IMAGE, VIDEO, DOCUMENT o LOCATION)
          name: null, // El nombre de la ubicación (solo para LOCATION)
        },
        formattedHeader: null, // El HEADER formateado (si es TEXT)
      },
      selectedTemplate: null,
      formattedBody: "", // BODY con los placeholders reemplazados
      selectedSegments: [],
      segments: [],
      buttons: [],
      loading: true, // Indicador de carga
      loadingSend: false,
      imageModal: false,
      activeTab: 0,

      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: true,
        rawText: "Campañas",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },

        fields: [
          {
            text: "id",
            value: "id",
          },
          {
            text: "Creado",
            value: "fechaCreado",
          },
          {
            text: "Actualizado",
            value: "fechaActualizado",
          },
          {
            text: "Plantilla",
            value: "nombrePlantilla",
            // canBeFiltered: true,
          },
          {
            text: "Mensajes enviados",
            value: "stringEnviados",
            // canBeFiltered: true,
          },
          {
            text: "Mensajes no enviados",
            value: "errores",
            // canBeFiltered: true,
          },
          {
            text: "Estatus",
            value: "st",
            canBeFiltered: true,
          },
        ],
      },

      actualListener: "",
      campañas: [],
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
    },

    autoImage(data, localUrl) {
      this.headerData.media.url = localUrl;
      this.headerData.media.sendingId = data.id;
      this.updateHeaderMediaUrl();
      this.imageModal = false;
    },

    // Sección de llamadas

    // Llamada realtime

    async getCampañas() {
      this.killListener(this.actualListener);
      const database = this.$store.getters.getFirebaseApp.database;
      const listener = "MKT/Campañas";

      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "MKT/Campañas",
        [database.orderByChild("ca", "desc"), database.limitToLast(50)],
        // null,
        (snapshot) => {
          try {
            if (snapshot.exists()) {
              // Crear el array de campañas
              const arrayCampañas = Object.entries(snapshot.val()).map(
                ([key, value]) => {
                  const fechaCreado = value.ca
                    ? moment(value.ca).format("DD/MM/YYYY HH:mm")
                    : "";
                  const fechaActualizado = value.ua
                    ? moment(value.ua).format("DD/MM/YYYY HH:mm")
                    : "";
                  const nombrePlantilla = value.pl?.nm || "";

                  // Valores predeterminados si tt no está definido
                  const enviados = value.tt ? value.tt.me : 1;
                  const errores = value.tt ? value.tt.er : 0;
                  const contactos = value.tt ? value.tt.cn : 1;

                  const stringEnviados = "Enviados " + (enviados - errores) + " mensajes a " + contactos + " contactos"

                  return {
                    id: key,
                    ...value,
                    fechaCreado,
                    fechaActualizado,
                    nombrePlantilla,
                    enviados,
                    errores,
                    contactos,
                    stringEnviados
                  };
                }
              );

              // Crear un Map para indexar las campañas por ID con su índice en el array
              const campañasIndexMap = new Map(
                arrayCampañas.map((campaña, idx) => [campaña.id, idx])
              );

              this.campañas = arrayCampañas;
              this.campañasIndexMap = campañasIndexMap;

            } else {
              console.log("No existe snapshot");
            }
          } catch (e) {
            console.error("Error", e);
          }
        }
      );
      // Comentado por ahora: this.actualListener = date;
    },

    killListener(listener) {
      if (listener != "") {
        const ref = this.$store.getters.getFirebaseApp.database.ref(listener);
        this.$store.getters.getFirebaseApp.database.off(ref);
      }
    },

    // createAxiosInstance() {
    //   return axiosCore.create({
    //     headers: {
    //       Authorization: "Bearer DEVELOPMENT",
    //       "Content-Type": "application/json",
    //     },
    //     transformRequest: (data) => JSON.stringify(data),
    //   });
    // },

    async getSegments() {
      return await this.$store.getters.getFirebaseApp.fba
        .call("MKT-Contactos-getSegmentos", {
          tenant: this.$store.getters.getFirebaseApp.tenant,
        })
        .then((result) => {
          // console.log("resultSegmentos", result.data.data);
          this.segments = result.data.data;
        })
        .catch((error) => {
          this.$pgsHelper.log(error);
        });
    },

    async getTemplates() {
      return await this.$store.getters.getFirebaseApp.fba
        .call("MKT-Plantillas-getPlantillas", {
          tenant: this.$store.getters.getFirebaseApp.tenant,
        })
        .then((result) => {
          let templates = result.data.data.data;
          templates.forEach((temp) => {
            temp.activeTab = 0;
          });
          this.templates = templates;
          this.loading = false;
        })
        .catch((error) => {
          this.$pgsHelper.log(error);
        });
    },
    // Termina sección de llamadas

    moveStep(forward) {
      if (forward) {
        if (this.step < 3) this.step++;
      } else {
        if (this.step > 1) {
          this.step--;
          if (this.step === 1) {
            this.resetFields();
          }
        }
      }
    },

    // Métodos para el step 2

    // Método para obtener el cuerpo del mensaje con los placeholders reemplazados
    getFormattedBody(body, placeholders) {
      if (typeof body !== "string") {
        // console.error("El parámetro 'body' debe ser un string.");
        return body;
      }

      let formattedBody = body;

      // Reemplaza los placeholders con los valores proporcionados
      Object.keys(placeholders).forEach((key) => {
        const value = placeholders[key] || `{{${key}}}`;
        const pattern = new RegExp(
          `\\*?_?\\*?\\{\\{${key}\\}\\}_?\\*?\\*?`,
          "g"
        );
        formattedBody = formattedBody.replace(pattern, value);
      });

      return formattedBody;
    },

    // Procesar ejemplos de cada template
    processExamples(example, key) {
      if (!example || !example[key]) return [];
      const value = example[key];

      // Si es un array, devuelve
      if (Array.isArray(value)) {
        return value.map((item) => (Array.isArray(item) ? item : [item]));
      }

      // Si no es un array, envuelve en array de arrays
      return [[value]];
    },

    // Colocar la media del header del componente
    setHeaderMedia(headerComponent) {
      this.headerData.media.url =
        this.processExamples(headerComponent.example, "header_handle")[0] || "";

      this.headerData.exist = true;

      // Permitir personalización dinámica
      this.updateHeaderMediaUrl = () => {
        headerComponent.example = headerComponent.example || {};
        headerComponent.example.header_handle = [
          this.headerData.media.url || "",
        ];
      };
    },

    // Procesar el header, encontrar su tipo y sus ejemplo
    processHeaderComponent(headerComponent) {
      // Si el HEADER no existe o no contiene datos significativos, marcar como no existente
      if (
        !headerComponent ||
        (!headerComponent.text && !headerComponent.example)
      ) {
        this.headerData.exist = false;
        return;
      }

      // Inicializar exist como true
      this.headerData.exist = true;

      const headerHandlers = {
        TEXT: () => {
          const exampleHeaderTexts = this.processExamples(
            headerComponent.example,
            "header_text"
          );

          if (!exampleHeaderTexts || exampleHeaderTexts.length === 0) {
            this.headerData.exist = false;
            return;
          }

          const firstExample = Array.isArray(exampleHeaderTexts)
            ? exampleHeaderTexts[0]
            : [];
          this.headerData.placeholders = this.processPlaceholders(
            headerComponent.text,
            firstExample.reduce((acc, val, i) => ({ ...acc, [i + 1]: val }), {})
          );

          if (Object.keys(this.headerData.placeholders).length === 0) {
            this.headerData.exist = false;
            return;
          }

          this.headerData.formattedHeader = this.getFormattedBody(
            headerComponent.text,
            this.headerData.placeholders
          );
        },
        LOCATION: () => {
          this.headerData.media.url =
            headerComponent.example?.location_url || null;
          this.headerData.media.name =
            headerComponent.example?.location_name || null;

          if (!this.headerData.media.url || !this.headerData.media.name) {
            this.headerData.exist = false;
          }
        },
        IMAGE: () => this.processMedia(headerComponent),
        VIDEO: () => this.processMedia(headerComponent),
        DOCUMENT: () => this.processMedia(headerComponent),
      };

      if (headerHandlers[headerComponent.format]) {
        headerHandlers[headerComponent.format]();
      } else {
        // console.warn(
        //   `Formato de HEADER desconocido: ${headerComponent.format}`
        // );
        this.headerData.exist = false;
      }
    },

    // Si tiene media se procesa
    processMedia(headerComponent) {
      // Procesa media asegurándose de que sea un string
      const mediaUrl = headerComponent.example?.header_handle?.[0] || null;

      if (mediaUrl && typeof mediaUrl === "string") {
        this.headerData.media.url = mediaUrl;
      } else {
        this.headerData.media.url = null;
        this.headerData.exist = false; // Si no hay URL válida, marcar como no existente
      }
    },

    // Procesa los textos de los templates introducidos para reconocer los patrones de placeholders.
    processPlaceholders(text, examples = {}) {
      const matches = text.match(/{{\w+}}/g) || [];
      return matches.reduce((placeholders, placeholder) => {
        const key = placeholder.replace(/[{}]/g, ""); // Limpia {{ }}
        placeholders[key] = examples[key] || ""; // Usa el ejemplo si existe
        return placeholders;
      }, {});
    },

    // Procesa los textos de los templates introducidos para reconocer los patrones de placeholders.
    extractPlaceholdersFromTemplate(template) {
      const bodyComponent = template.components.find((c) => c.type === "BODY");
      if (!bodyComponent) return {};

      // Obtener todos los ejemplos como un array
      const exampleBodyTexts = this.processExamples(
        bodyComponent.example,
        "body_text"
      );

      // Seleccionar el primer ejemplo
      const firstExample = exampleBodyTexts[0] || [];

      // Mapear placeholders a sus valores usando el primer ejemplo
      return this.processPlaceholders(
        bodyComponent.text,
        firstExample.reduce((acc, val, i) => ({ ...acc, [i + 1]: val }), {})
      );
    },

    // Permite actualizar la url del template dependiendo del tipo.
    updateHeaderMediaUrl() {
      const headerComponent = this.selectedTemplate.components.find(
        (c) => c.type === "HEADER"
      );

      if (!headerComponent) return;

      // Actualizar los datos de media dependiendo del tipo de HEADER
      if (this.headerData.type === "LOCATION") {
        headerComponent.example = headerComponent.example || {};
        headerComponent.example.location_url = this.headerData.media.url || "";
        headerComponent.example.location_name =
          this.headerData.media.name || "";
      } else if (
        ["IMAGE", "VIDEO", "DOCUMENT"].includes(this.headerData.type)
      ) {
        headerComponent.example = headerComponent.example || {};
        headerComponent.example.header_handle = [
          this.headerData.media.url || "",
        ];
      }
    },

    // Usado para actualizar el header si es texto.
    updateFormattedHeader() {
      if (this.headerData.type === "TEXT") {
        const headerComponent = this.selectedTemplate.components.find(
          (c) => c.type === "HEADER" && c.format === "TEXT"
        );
        if (headerComponent) {
          this.headerData.formattedHeader = this.getFormattedBody(
            headerComponent.text,
            this.headerData.placeholders
          );
        }
      }
    },

    // Usado para actualizar el body.
    updateFormattedBody() {
      if (this.selectedTemplate) {
        const bodyComponent = this.selectedTemplate.components.find(
          (c) => c.type === "BODY"
        );

        if (bodyComponent) {
          this.formattedBody = this.getFormattedBody(
            bodyComponent.text,
            this.placeholders
          );
        }
      }
    },

    // Extrae los botones que la componente trae, usado únicamente para
    extractButtons(template) {
      const buttonsComponent = template.components.find(
        (c) => c.type === "BUTTONS"
      );

      if (!buttonsComponent) {
        return [];
      }

      // Construye una lista con los botones y sus propiedades, para mostrarlo en el mensaje.
      return buttonsComponent.buttons.map((button, index) => ({
        type: button.type,
        text: button.text,
        url: button.type === "URL" ? button.url : null, // Solo URL si el tipo es "URL"
        index, // Para referenciar cada botón
      }));
    },

    // updateButton(index, key, value) {
    //   if (!this.buttons[index]) return;

    //   // Actualiza el valor correspondiente
    //   this.buttons[index][key] = value;

    //   // Si el botón es de tipo URL, actualiza su propiedad URL también
    //   if (key === "url" && this.buttons[index].type === "URL") {
    //     const buttonsComponent = this.selectedTemplate.components.find(
    //       (c) => c.type === "BUTTONS"
    //     );
    //     if (buttonsComponent && buttonsComponent.buttons[index]) {
    //       buttonsComponent.buttons[index].url = value;
    //     }
    //   }
    // },

    // Selecciona el template que se va a usar.
    selectTemplate(template) {
      this.selectedTemplate = template;

      const headerComponent = template.components.find(
        (c) => c.type === "HEADER"
      );

      if (headerComponent) {
        this.headerData.type = headerComponent.format;
        this.processHeaderComponent(headerComponent);
      }

      // Extraer placeholders
      this.placeholders = this.extractPlaceholdersFromTemplate(template);
      this.buttons = this.extractButtons(template);

      // Actualizar textos formateados
      this.updateFormattedBody();
      this.updateFormattedHeader();

      // Permitir personalización dinámica de media
      if (this.updateHeaderMediaUrl) {
        this.updateHeaderMediaUrl();
      }

      this.step = 2;
    },

    // Aquí termina //

    // Sección de envío

    // Método para generar el payload de lo que vamos a enviar en la función.
    generatePayload() {
      const components = [];

      // HEADER
      const headerMedia = this.headerData.type;

      if (headerMedia) {
        if (
          headerMedia === "LOCATION" &&
          this.headerData.media.name &&
          this.headerData.media.url
        ) {
          components.push({
            type: "header",
            parameters: [
              {
                type: "LOCATION NAME",
                text: this.headerData.media.name, // Nombre de la ubicación
              },
              {
                type: "ADDRESS",
                text: this.headerData.media.url, // URL de la ubicación
              },
            ],
          });
        } else if (
          ["IMAGE", "VIDEO", "DOCUMENT"].includes(headerMedia) &&
          (this.headerData.media.sendingUrl || this.headerData.media.url)
        ) {
          components.push({
            type: "header",
            parameters: [
              {
                type: headerMedia.toLowerCase(), // image, video, o document
                [headerMedia.toLowerCase()]: {
                  id:
                    this.headerData.media.sendingId ||
                    this.headerData.media.url, // Usa el enlace directo}
                },
              },
            ],
          });
        } else if (headerMedia === "TEXT") {
          // Extraer el texto del HEADER desde el template seleccionado
          const headerText = this.selectedTemplate.components.find(
            (c) => c.type === "HEADER" && c.format === "TEXT"
          )?.text;

          if (headerText) {
            // Buscar placeholders en el texto del HEADER
            const headerPlaceholders = headerText.match(/{{\d+}}/g) || [];

            // Generar parámetros para el HEADER
            const headerParameters = headerPlaceholders
              .map((placeholder, index) => {
                const resolvedValue =
                  this.headerData.placeholders[index + 1] || "";
                return {
                  type: "text", // Tipo debe ser "text" para el payload
                  text: resolvedValue,
                };
              })
              .filter((param) => param.text.trim() !== ""); // Filtrar parámetros vacíos

            // Agregar al payload solo si hay parámetros válidos
            if (headerParameters.length > 0) {
              components.push({
                type: "header",
                parameters: headerParameters,
              });
            }
          }
        }
      }

      // BODY
      const bodyComponent = this.selectedTemplate.components.find(
        (c) => c.type === "BODY"
      );

      if (bodyComponent && this.formattedBody) {
        // Extrae los placeholders del BODY
        const bodyPlaceholders = bodyComponent.text.match(/{{\d+}}/g) || [];

        // Genera los parámetros del BODY
        const bodyParameters = bodyPlaceholders
          .map((placeholder, index) => {
            const resolvedValue = this.placeholders[index + 1] || "";
            return {
              type: "text",
              text: resolvedValue, // Valor resuelto para el placeholder
            };
          })
          .filter((param) => param.text.trim() !== ""); // Filtra parámetros vacíos

        if (bodyParameters.length > 0) {
          components.push({
            type: "body",
            parameters: bodyParameters,
          });
        }
      }

      // Construcción final del payload
      const payload = {
        segmento: this.selectedSegments, // Enviar los segmentos seleccionados
        plantilla: {
          id: this.selectedTemplate.id,
          name: this.selectedTemplate.name,
          language: {
            code: this.selectedTemplate.language,
          },
          components: components.length > 0 ? components : undefined, // Solo incluir components si hay contenido
        },
      };

      return payload;
    },

    // Método para enviar
    sendMessageToSegments() {
      const payload = this.generatePayload();
      if (!payload) return;

      this.$swal({
        title: "¿Deseas enviar este mensaje?",
        text: "El mensaje será enviado al segmento: " + payload.segmento,
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Enviar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MKT-Campanias-sendCampania", payload)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            let sended =
              result.value.data.data.total_count -
              result.value.data.data.not_send;
            this.loadingSend = false;
            this.$alert.alert({
              title: "Mensaje enviado",
              subtitle:
                "Enviados " +
                sended +
                " mensajes de " +
                result.value.data.data.total_count +
                " contactos",
            });
            this.resetFields();
            this.step = 1;
          } else {
            this.$swal("Error saving data", result.value.data.error, "error");
          }
        }
      });
    },

    // async sendMessageToSegments() {
    //   const payload = this.generatePayload();
    //   if (!payload) return;

    //   // Crear la instancia de Axios usando el método reutilizable
    //   const axiosInstance = this.createAxiosInstance();

    //   let urlEp =
    //     "https://us-central1-crisp-testing-7ac18.cloudfunctions.net/MKT-EnvioMasivoWhats-envioMasivoByTemplate?tenant=TENANT_1";

    //   try {
    //     const response = await axiosInstance.post(urlEp, payload);
    //     await this.getTemplates();
    //     let responseData = response.data.data;
    //     if (responseData.ok) {
    //       let sended =
    //         responseData.data.total_count - responseData.data.not_send;
    //       this.loadingSend = false;
    //       this.$alert.alert({
    //         title: "Mensaje enviado",
    //         subtitle:
    //           "Enviados " +
    //           sended +
    //           " mensajes de " +
    //           responseData.data.total_count +
    //           " contactos",
    //       });
    //       this.resetFields();
    //       this.step = 1;
    //     } else {
    //       this.$alert.alert("Error al enviar mensaje");
    //     }
    //   } catch (error) {
    //     console.error("Error in POST request:", error);
    //   }
    // },

    resetFields() {
      this.placeholders = {}; // Resetea los placeholders
      this.mediaUrl = ""; // Resetea la URL de la imagen
      this.formattedBody = ""; // Resetea el cuerpo del mensaje formateado
      this.selectedTemplate = null; // Deselecciona el template
      this.selectedSegments = []; // Deselecciona los segmentos
      this.headerData = {
        exist: false,
        type: null, // El tipo de HEADER (TEXT, IMAGE, VIDEO, DOCUMENT, LOCATION)
        placeholders: {}, // Los placeholders del HEADER (si es TEXT)
        media: {
          url: null, // La URL de media (IMAGE, VIDEO, DOCUMENT o LOCATION)
          name: null, // El nombre de la ubicación (solo para LOCATION)
        },
        formattedHeader: null, // El HEADER formateado (si es TEXT)
      };
    },
  },

  computed: {
    placeholdersFilled() {
      const headerComplete =
        this.headerData.type === "LOCATION"
          ? this.headerData.media.url.trim() !== "" &&
            this.headerData.media.name.trim() !== ""
          : this.headerData.type === "TEXT"
          ? Object.values(this.headerData.placeholders).every(
              (value) => value.trim() !== ""
            )
          : true;

      const bodyComplete = Object.values(this.placeholders).every(
        (value) => value.trim() !== ""
      );

      return headerComplete && bodyComplete;
    },
  },
  beforeMount() {
    this.getSegments();
    this.getTemplates();
    this.getCampañas();
  },
};
</script>

<style scoped>
.v-tab-like {
  position: relative;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.v-tab-like:hover {
  color: #007bff;
}

.v-tab-like::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #007bff;
  transition: width 0.3s ease;
}

.v-tab-like:hover::after {
  width: 100%;
}

.whatsapp-message {
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: #f2f2f2;
  border-radius: 10px;
  max-width: 400px;
  margin: 0 auto;
}

.message-header {
  font-size: 14px;
  color: #00796b;
  margin-bottom: 8px;
}

.message-body {
  background-color: #dcf8c6;
  padding: 10px;
  border-radius: 10px;
  font-size: 16px;
  color: #303030;
  max-width: 100%;
}

.message-footer {
  margin-top: 12px;
  font-size: 12px;
  color: #757575;
  text-align: right;
}

.iframe {
  max-width: 100%;
  max-height: 200px; /* Ajusta según tus necesidades */
  border: none; /* Elimina bordes si no los necesitas */
  border-radius: 10px; /* Para consistencia visual */
  display: block; /* Asegura que respete el flujo de diseño */
  margin: 0 auto; /* Centra horizontalmente */
  object-fit: contain; /* Asegura que el contenido se ajuste */
}

.button-container {
  display: flex;
  flex-direction: column;
  gap: 8px; /* Espaciado entre botones */
  align-items: stretch; /* Asegura que los botones ocupen el ancho completo */
}

.button-container .v-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff; /* Fondo blanco */
  border: 1px solid #d1d1d1; /* Borde sutil */
  color: #00796b; /* Color principal */
  font-size: 14px; /* Tamaño de texto más pequeño */
  padding: 8px 16px; /* Espaciado interno */
  border-radius: 5px; /* Bordes redondeados */
  text-transform: none; /* Quitar mayúsculas */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* Sombra sutil */
  transition: background-color 0.2s, box-shadow 0.2s; /* Transiciones suaves */
}

.button-container .v-btn:hover {
  background-color: #f0f0f0; /* Fondo más claro al pasar el mouse */
}

.button-container .v-btn:active {
  background-color: #e0e0e0; /* Fondo aún más oscuro al presionar */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); /* Reducir la sombra */
}

.button-container .v-btn[disabled] {
  background-color: #f5f5f5; /* Fondo para botones deshabilitados */
  border-color: #e0e0e0; /* Borde para botones deshabilitados */
  color: #bdbdbd; /* Texto gris */
}

.button-container .v-btn .v-icon {
  margin-right: 8px; /* Espaciado entre icono y texto */
  font-size: 18px; /* Tamaño del icono */
}

.v-btn {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 8px;
}

.v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}

.v-btn:active {
  transform: translateY(0);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 0;
  border-radius: 10px;
  overflow: hidden;
}

/* Ocultar las flechas automáticas */
.no-scrollbar .v-slide-group__prev,
.no-scrollbar .v-slide-group__next {
  display: none !important;
}

/* Forzar que cada pestaña ocupe el 50% del ancho */
.fixed-tab {
  flex: 1 1 50%; /* Divide en dos partes iguales */
  max-width: 50%; /* Máximo 50% */
  text-align: center; /* Centra el texto */
  padding: 0 8px;
}

/* Truncar el texto con ellipsis */
.tab-text {
  display: block;
  white-space: nowrap; /* Evita que el texto salte de línea */
  overflow: hidden; /* Oculta el texto que se desborda */
  text-overflow: ellipsis; /* Muestra los puntos suspensivos (...) */
}
</style>
